<template lang="pug">
    #estimates
        v-toolbar(elevation="2" height="88")
            v-toolbar-title.text-h4.font-weight-bold {{title}}
            v-spacer
            v-btn.ml-6(rounded color="primary"  @click="$router.push({name: 'EstimateNew'})") {{$t('EstimatesAndInvoices.__CreateEstimate')}}

        v-container
            .action-bar.mb-8
                v-row
                    v-spacer
                    v-col(cols="12" md="3")
                        v-select(v-model="selectedStatus" solo dense clearable outlined hide-details :items="statusItems" item-text="text" item-value="key" :placeholder="$t('Placeholder.__Status')")
                    v-col(cols="12" md="3")
                        CustomerSelector(v-model="customer" :insert-tag="false")
                        //- v-select(v-model="customer" solo dense clearable outlined hide-details return-object  :items="customers" item-text="name" item-value="id"  :placeholder="$t('Placeholder.__Customer')")
                    v-col(cols="12" md="3")
                        v-menu(v-model="rangeDateMenu" offset-y :close-on-content-click="false" :nudge-right="40" transition="scale-transition"  min-width="290px")
                            template(v-slot:activator="{ on }")
                                v-text-field(:value="dateRangeText" clearable hide-details solo dense outlined readonly append-icon="event" v-on="on" :placeholder="$t('Placeholder.__DateRange')" @click:clear="dates=[]")
                            v-date-picker(v-model="dates" @input="rangeDateMenu =(dates.length==2)? false: true" range :locale="$store.getters['account/language']() == 'tw'? 'zn-tw': ''")
            Alert
            ConfirmDialog(v-model="deleteDialog" :title="$t('EstimatesAndInvoices.__DeleteEstimate')" :message="$t('EstimatesAndInvoices.__ConfirmDeleteEstimate')" :cancel-text="$t('ActionOption.__Cancel')" :confirm-text="$t('ActionOption.__Delete')" :confirm-action="deleteEstimate")

            v-data-table.mb-6(:headers="headers" :items="filteredEstimates" hide-default-footer :options.sync="options" :loading="loading" :custom-sort="defaultDataSort")
                
                template(v-slot:item.status="{item}")
                    v-chip(dark small :color="getStatusColor(item.status)") {{$t('Status.__' + item.status)}}
                template(v-slot:item.name="{item}") 
                    a(@click="viewItem(item)" style="text-decoration:underline;") {{item.name}}
                template(v-slot:item.number="{item}" ) 
                    a(@click="viewItem(item)"  style="text-decoration:underline;") {{item.number}}
                template(v-slot:item.amount="{item}")
                    span {{getAmountWithCurrency(item.amount, currencyCode)}}
                template(v-slot:item.customerName="{item}")
                    span {{item.customer.name}}
                template(v-slot:item.actions="{item}")
                    v-menu(bottom left)
                        template(v-slot:activator="{ on }")
                            v-btn(icon v-on="on")
                                v-icon( outlined color="gray") keyboard_arrow_down
                        v-list
                            template(v-for="(menu, i) in actionItems")
                                v-list-item(:key="i" @click="menu.click(item)")
                                    v-list-item-title {{menu.title}}
                                v-divider(v-if="menu.divider")
            
            v-row.pagination-row
                v-col.d-flex.align-center.justify-start(cols="6")
                    span.mr-2.d-none.d-md-block {{$t("Table.__ItemsPerPage")}}
                    span
                        v-select.page-select(v-model="options.itemsPerPage" solo dense outlined hide-details :items="perPageItems")
                v-col.d-flex.align-center.justify-end(cols="6")
                    v-pagination(v-model="options.page" :length="pageCount")

            SharedLinkDialog(v-model="sharedDialog" :link="sharedLink" :title="$t('EstimatesAndInvoices.__ShareEstimate')" :message="$t('EstimatesAndInvoices.__ShareHint')" :confirmText="$t('EstimatesAndInvoices.__CopyLink')" )
            SendingEmailDialog(v-model="sendEmailDialog" :title="$t('EstimatesAndInvoices.__SendEstimate')" radioSubtitleKey="EstimatesAndInvoices.__SendInvoiceToCustomer" :customer="selectEstimate.customer" category="estimate" :id="selectEstimate.id")
            ConfirmDialog(v-model="convertDialog" :title="$t('EstimatesAndInvoices.__ConvertToInvoice')" :message="$t('EstimatesAndInvoices.__ConvertHint')" :cancel-text="$t('ActionOption.__Cancel')" :confirm-text="$t('ActionOption.__Convert')" :confirm-action="convertEstimate2Invoice")

</template>
<script>
import SendingEmailDialog from "@/components/dialogs/SendingEmailDialog"
import SharedLinkDialog from "@/components/dialogs/SharedLinkDialog"

import * as TimeHelper from "@/utils/timeHelper"
import * as currencyHelper from "@/utils/currencies"
import * as PDF from "@/utils/pdf"
import * as datatableHelper from "@/utils/datatableHelper.js"

export default {
  components: {
    SendingEmailDialog,
    SharedLinkDialog
  },
  props: ["alert"],
  mixins: [currencyHelper.mixin, TimeHelper.mixin, datatableHelper.mixin],
  data() {
    return {
      perPageItems: [10, 25, 50],
      pageCount: 0,
      options: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] },
      loading: false,
      filters: {},

      sendEmailDialog: false,
      convertDialog: false,
      title: this.$t("Menu.__Sales") + " : " + this.$t("Menu.__Estimate"),
      deleteDialog: false,
      deleteId: 0,
      sharedDialog: false,
      sharedLink: "",
      selectedStatus: "",
      selectEstimate: {},
      statusItems: [
        // {
        //     text: this.$t("Status.__Draft"),
        //     color: "#dcdcdc",
        //     key: "Draft"
        // },
        {
          text: this.$t("Status.__Unsent"),
          color: "#505356",
          key: "Unsent"
        },
        {
          text: this.$t("Status.__Sent"),
          color: "#14c8c8",
          key: "Sent"
        },
        {
          text: this.$t("Status.__Viewed"),
          color: "primary",
          key: "Viewed"
        },
        {
          text: this.$t("Status.__Expired"),
          color: "#e6465a",
          key: "Expired"
        }
      ],
      customer: null,
      customers: [],
      actionItems: [
        { title: this.$t("ActionOption.__View"), click: this.viewItem },
        {
          title: this.$t("EstimatesAndInvoices.__Edit"),
          click: this.editItem
        },
        {
          title: this.$t("ActionOption.__Duplicate"),
          divider: true,
          click: this.duplicateEstimate
        },
        {
          title: this.$t("EstimatesAndInvoices.__ConvertToInvoice"),
          click: this.convert,
          divider: true
        },
        {
          title: this.$t("EstimatesAndInvoices.__SendVia2SUMUP"),
          click: this.sendEmail
        },
        {
          title: this.$t("EstimatesAndInvoices.__GetLink"),
          click: this.shareLink
        },
        {
          title: this.$t("ActionOption.__ExportPDF"),
          click: this.downloadPDF
        },
        {
          title: this.$t("ActionOption.__Print"),
          divider: true,
          click: this.printItem
        },
        {
          title: this.$t("ActionOption.__Delete"),
          click: this.deleteItem
        }
      ],
      rangeDateMenu: false,
      dates: [],
      sortedDate: [],
      searchText: "",
      headers: [
        {
          text: this.$t("EstimatesAndInvoices.__Status"),
          align: "start",
          sortable: true,
          value: "status"
        },
        {
          text: this.$t("EstimatesAndInvoices.__Title"),
          align: "start",
          sortable: true,
          value: "name"
        },
        {
          text: this.$t("EstimatesAndInvoices.__EstimateDate"),
          align: "start",
          sortable: true,
          value: "issuedAt"
        },
        {
          text: this.$t("EstimatesAndInvoices.__No"),
          align: "start",
          sortable: true,
          value: "number"
        },
        {
          text: this.$t("EstimatesAndInvoices.__Customer"),
          align: "start",
          sortable: true,
          value: "customerName"
        },
        {
          text: this.$t("EstimatesAndInvoices.__EstimateAmountInList"),
          align: "end",
          sortable: true,
          value: "amount"
        },
        {
          text: "",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ],
      estimates: [],
      filteredEstimates: []
    }
  },
  watch: {
    dates(value) {
      if (this.dates.length > 0) {
        this.filters.from = this.dates[0]
        this.filters.to = this.dates.length == 2 ? this.dates[1] : this.dates[0]
      } else {
        delete this.filters["from"]
        delete this.filters["to"]
      }
      this.getEstimates()
    },
    customer(value) {
      if (this.customer) {
        this.filters.customerId = this.customer.id
      } else {
        delete this.filters["customerId"]
      }

      this.getEstimates()
    },
    selectedStatus(value) {
      if (this.selectedStatus) {
        this.filters.status = this.selectedStatus
      } else {
        delete this.filters["status"]
      }

      this.getEstimates()
    },
    options: {
      handler() {
        this.getEstimates()
      },
      deep: true
    }
  },
  methods: {
    // filterEstimates() {
    // this.filteredEstimates = this.estimates
    // this.filteredEstimates = this.filteredEstimates.filter(item => {
    //     return this.selectedStatus == null
    //         ? true
    //         : item.status == this.selectedStatus
    // })
    // this.filteredEstimates = this.filteredEstimates.filter(item => {
    //     return this.customer == null
    //         ? true
    //         : item.customer.id == this.customer.id
    // })
    // this.filteredEstimates = this.filteredEstimates.filter(item => {
    //     if (this.dates.length == 0) return true
    //     var dates = this.dates.slice().sort()
    //     var issuedAtTimestamp = this.date2unixtimestamp(item.issuedAt)
    //     var date1Timestamp = this.date2unixtimestamp(dates[0])
    //     var date2Timestamp = dates[1]
    //         ? this.date2unixtimestamp(dates[1])
    //         : 0
    //     return this.dates.length == 1
    //         ? issuedAtTimestamp == date1Timestamp
    //         : issuedAtTimestamp >= date1Timestamp &&
    //               issuedAtTimestamp <= date2Timestamp
    // })
    // },
    getEstimates(initTag) {
      var query = this.datatableOptionsToQuery(this.options)
      query = Object.assign({}, query, this.filters)
      this.loading = true
      // this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("estimates/getEstimates", query)
        .then(
          function(response) {
            this.filteredEstimates = this.estimates = response.data
            this.pageCount = response.paging.totalPages
            this.loading = false
            if (initTag) {
              this.customers = this.estimates.map(function(est) {
                return {
                  id: est.customer.id,
                  name: est.customer.name
                }
              })
            }
            // this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.loading = false
            // this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },

    printItem(item) {
      var id = item.id
      this.$router.push({
        name: "EstimateExport",
        params: {
          estimateId: id,
          exportType: "print"
        }
      })
    },
    editItem(item) {
      var id = item.id
      this.$router.push({
        name: "EstimateEdit",
        params: {
          id: id
        }
      })
    },
    viewItem(item) {
      var id = item.id
      this.$router.push({
        name: "EstimateView",
        params: {
          id: id
        }
      })
    },
    sendEmail(item) {
      this.selectEstimate = item
      this.sendEmailDialog = true
    },
    duplicateEstimate(item) {
      this.$store
        .dispatch("estimates/duplicateEstimate", item.id)
        .then(
          function(response) {
            this.$store.dispatch("global/stopLoading")
            this.getEstimates()
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyDuplicated"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    convert(item) {
      this.selectEstimate = item
      this.convertDialog = true
    },
    convertEstimate2Invoice() {
      this.$store
        .dispatch("estimates/convertEstimate2Invoice", this.selectEstimate.id)
        .then(
          function(response) {
            this.$store.dispatch("global/stopLoading")
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyConverted"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
      this.convertDialog = false
    },
    shareLink(item) {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("estimates/shareEstimate", item.id)
        .then(
          function(response) {
            var token = response.data.token
            this.sharedLink = process.env.VUE_APP_DOMAIN + "share/estimates/" + token

            this.sharedDialog = true

            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(function(error) {}.bind(this))
    },
    deleteItem(item) {
      this.deleteDialog = true
      this.deleteId = item.id
    },
    getStatusColor(status) {
      for (var item of this.statusItems) {
        if (item.key == status) {
          return item.color
        }
      }
    },

    deleteEstimate() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("estimates/deleteEstimate", this.deleteId)
        .then(
          function(response) {
            this.getEstimates()
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyDeleted"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
      this.deleteDialog = false
    },
    downloadPDF(item) {
      // this.$store.dispatch("global/startLoading")
      var id = item.id
      this.$router.push({
        name: "EstimateExport",
        params: {
          estimateId: id,
          exportType: "download"
        }
      })
    }
  },
  computed: {
    dateRangeText() {
      return this.dates
        .slice()
        .sort()
        .join(" ~ ")
    }
    // customers() {
    //     return this.estimates.map(function(est) {
    //         return { id: est.customer.id, name: est.customer.name }
    //     })
    // }
  },
  mounted() {
    if (this.alert) {
      this.$store.dispatch("global/showAlert", this.alert)
    }
  },
  created() {
    this.getEstimates(true)
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/formcontrol.scss";
</style>
